module.exports = __webpack_public_path__ + "img/drop_left.91206203.svg";